module.exports = __webpack_public_path__ + "static/media/icon-heart-active@2x.2b152185.png";